// extracted by mini-css-extract-plugin
export default {"CardHeader":"CardHeader_CardHeader__ZYydy","Intro":"CardHeader_Intro__aYrZQ","Title":"CardHeader_Title__YJ-d9","Subtitle":"CardHeader_Subtitle__OKz9V"};